import { g as o } from "./getScrollbarWidth-usY8URQC.js";
import { createGlobalStyle as e, css as t } from "styled-components";
const s = e`
  body {
    ${({ prevent: r }) => r && t`
        overflow: hidden;
        //* Reserve scrollbar space
        padding-right: ${o()}px !important;
      `}
  }
`;
export {
  s as P
};
